<template>
  <PageWrapper
    :active-page="PAGE_PUBLICATION_INVITED_TO_COLLABORATE"
    :active-section="SECTION_PUBLICATIONS"
    title="Proposals"
    :breadcrumbs="publicationBreadCrumbs"
    page-name="Proposals"
    align="left"
    width="full"
  >
    <SmartFeed
      :source="useMyCollaboratorInviteFeedStore"
      default-feed-layout="table"
    >
      <template #empty-state>
        <iColumn gap="extraSmall" align="left">
          <iText variant="subtle">
            You currently have no pending invitations to collaborate on any
            publications.
          </iText>
        </iColumn>
      </template>
    </SmartFeed>

    <InvitationReviewModal
      v-if="isInvitationReviewModalVisible"
      :invitation="selectedInvitationReview"
      @close="closeInvitationReviewModal"
      @accept="onAcceptInvitation"
      @decline="onDeclineInvitation"
      @counter="onCounterInvitation"
    />

    <ProposalReviewModal
      v-if="isProposalReviewModalVisible"
      :proposal="selectedProposalReview"
      @close="closeProposalReviewModal"
      @accept="onAcceptInvitation"
      @decline="onDeclineInvitation"
      @counter="onCounterInvitation"
    />

    <CounterOfferModal
      v-if="isCounterOfferModalVisible"
      :proposal="selectedProposalForCounter"
      @close="closeCounterOfferModal"
      @cancel="onCancelCounterOffer"
      @submit="onSubmitCounterOffer"
    />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  PAGE_COLLABORATOR_PROPOSALS,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import CounterOfferModal from "@/components/publication/CounterOfferModal.vue";
import InvitationReviewModal from "@/pages/publication/InvitationReviewModal.vue";
import ProposalReviewModal from "@/components/publication/ProposalReviewModal.vue";
import { useMyCollaboratorInviteFeedStore } from "@/smart-feed/stores/feed/my-collaborator-invite-feed-store";
import collaboratorInviteMixin from "@/mixins/collaborator-invite-mixin";

export default {
  name: "CollaboratorInvites",
  components: {
    InvitationReviewModal,
    ProposalReviewModal,
    CounterOfferModal,
    SmartFeed,
    PageWrapper,
  },
  mixins: [collaboratorInviteMixin],
  data() {
    return {
      PAGE_PUBLICATION_INVITED_TO_COLLABORATE: PAGE_COLLABORATOR_PROPOSALS,
      SECTION_PUBLICATIONS,
    };
  },
  computed: {
    publicationBreadCrumbs() {
      return [{ url: "/", label: "Home" }];
    },
  },
  methods: {
    useMyCollaboratorInviteFeedStore,
  },
};
</script>
